import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UrlSignature } from '../common/apiEndpoint';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Administrator } from './Administrator';

@Injectable()
export class LoginService {
  constructor(
    private httpClient: HttpClient,
    private urlSignature: UrlSignature,
  ) {}

  getAdminstratorDetails(
    userMail: string,
    password: string,
  ): Observable<Administrator> {
     const url =
      this.urlSignature.loginAuthUrl;
    return this.httpClient
      .post(url,{userName:userMail, password})
      .pipe(map((response) => response as Administrator));
  }
}
